import React from 'react';
import VocabularyTypesList from './VocabularyTypesList';
/**
 * Route wrapper for Nastavení → Slovníky (CZNA-1470). Create and rename are modals over
 * the list, so there are no nested routes. Mirrors `DerivationRules.tsx`.
 */
var VocabularyTypes = function () { return React.createElement(VocabularyTypesList, null); };
export default VocabularyTypes;
